import type { NextPage } from 'next';
import { getParticipantsCount } from '../../api/helpers/getParticipantsCount';
import { Customers } from '../../components/Customers';
import Meta from '../../components/Meta';
import { metaTags } from '../../components/_dummyData';
import { useBreadcrumbs } from '../../components/_shared/Breadcrumbs/BreadcrumbsContext';

const CustomersPage: NextPage = () => {
    useBreadcrumbs([{ title: 'Заказчикам' }]);
    const participantCount = getParticipantsCount(new Date());

    return (
        <>
            <Meta
                title={metaTags.customers.title}
                description={metaTags.customers.description}
                url={metaTags.customers.url}
            />
            <Customers participantCount={participantCount} />
        </>
    );
};

export default CustomersPage;
